export default "__VITE_ASSET__4f68d9ee__"